import { useRedeemLoaderData } from "./redeemLoader.ts";
import { useEffect } from "react";
import useSingleToast from "../../root/core-ui/toast/useSingleToast.ts";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import RedeemToast from "../actions/redeem/RedeemToast.tsx";

export default function RedeemMain() {
  const result = useRedeemLoaderData();
  const [showToast] = useSingleToast();
  const intl = useIntl();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    showToast(
      <RedeemToast
        ok={result.ok}
        books={result.data?.books}
        code={params.code!}
      />
    );
    void navigate("/my-library");
  }, [result, showToast, intl, navigate, params]);

  return null;
}
